import get from 'get-value';
import {TECH_DOC_INTERNAL_TICKET_LIST_FETCH_PENDING} from '../../actions/techDoc/actionTechDocInternalTicketListPage';
import {
    TECH_DOC_INTERNAL_TICKET_LOCKED,
    TECH_DOC_INTERNAL_TICKET_LOCKED_ERROR,
    TECH_DOC_INTERNAL_TICKET_LOCKED_FATAL
} from '../../constants/websocketCommands';
import {TECH_DOC_INTERNAL_RESET_REDIRECT, TECH_DOC_INTERNAL_SET_LOCK_TICKET} from '../../actions/techDoc/actionTechDocInternalLockTicket';
import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';

export const techDocInternalTicketListPage = (state = {
    correlationId: null,
    isLoading: false,
    isTableLoading: false,
    listData: [],
    pages: 0,
    isNextFromPivot: true,
    isNextPage: false,
}, action) => {
    switch (action.type) {
        case TECH_DOC_INTERNAL_TICKET_LIST_FETCH_PENDING: {
            return Object.assign({}, state, {isTableLoading: true});
        }
        case techDocWebsocketCommands.TECH_DOC_INTERNAL_TICKET_LIST_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isTableLoading: false,
                    listData: get(action, 'payload.result.data', {default: []}),
                    pages: get(action, 'payload.result.pages', {default: 0}),
                    isNextFromPivot: get(action, 'payload.result.isNextFromPivot', false),
                    isNextPage: get(action, 'payload.result.isNextPage', false),
                    correlationId
                });
            }
        }
        case techDocWebsocketCommands.TECH_DOC_INTERNAL_TICKET_LIST_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {isTableLoading: false, correlationId});
            }
        }
        default:
            return state;
    }
};

export const techDocInternalTicketListOrderLockTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case TECH_DOC_INTERNAL_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case TECH_DOC_INTERNAL_TICKET_LOCKED_ERROR:
        case TECH_DOC_INTERNAL_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case TECH_DOC_INTERNAL_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case TECH_DOC_INTERNAL_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
